import { Grid } from '@mui/material';
import { useMemo } from 'react';
import { useParams } from 'react-router';

import { NegotiationCaseCancelledAlert } from '@/legacy/components/NegotiationCaseCancelledAlert/NegotiationCaseCancelledAlert';
import { ModuleEntityType } from '~/common/types';
import { ModuleContextProvider, ModuleContextProviderValue } from '~/components/ModuleContextProvider';
import { ModulePage } from '~/components/ModulePage/ModulePage';
import { useModulePageConfig } from '~/components/ModulePageConfigProvider';
import { ModuleSlot } from '~/components/ModuleSlot/ModuleSlot';
import { useProcessStepsAutoRefresh } from '~/hooks/useProcessStepsAutoRefresh/useProcessStepsAutoRefresh';
import { ProcessStepsAutoRefreshVariant } from '~/hooks/useProcessStepsAutoRefresh/useProcessStepsAutoRefresh.util';
import { ModuleSlotId } from '~/modules';
import { RouteId } from '~/routes';

import { NegotiationDetailHeader } from './NegotiationDetailHeader/NegotiationDetailHeader';

export const NegotiationCaseDetail = () => {
  const { negotiationId, tabId } = useParams() as { negotiationId: string; tabId?: string };
  const { modules, tabs } = useModulePageConfig({ pageId: RouteId.negotiationDetail(), tabId });

  const contextValue = useMemo<ModuleContextProviderValue>(
    () => ({ entity: ModuleEntityType.NEGOTIATION_CASE, entityId: negotiationId }),
    [negotiationId],
  );

  useProcessStepsAutoRefresh({
    variant: ProcessStepsAutoRefreshVariant.NEGOTIATION_CASE_DETAIL,
    id: negotiationId,
  });

  return (
    <ModulePage
      header={<NegotiationDetailHeader id={negotiationId} tabs={tabs} />}
      modules={
        <ModuleContextProvider value={contextValue}>
          <>
            <Grid size={12}>
              <NegotiationCaseCancelledAlert negotiationCaseId={negotiationId} />
            </Grid>
            <ModuleSlot id={ModuleSlotId.MAIN} modules={modules} />
          </>
        </ModuleContextProvider>
      }
    />
  );
};
